export enum LoginSteps {
    EMAIL = 'email',
    OTP = 'otp',
}
